import React from "react";
import { Link } from "react-router-dom";
import { DataTable } from "@cxagroup/casper";
import { injectIntl } from "react-intl";
import { RouteMap } from "components/common/navigation/routeMap";
import { decodeHtmlContent, renderAsHTML } from "../../../utils";

const SearchEmployeeDelegationTable = injectIntl(
  ({ results: { employeeList: employees = [] }, children, onAddEmployee, intl }) => {
    const columns = [
      {
        fieldId: "employeeName",
        displayLabel: "Employee Name",
        shouldDisplay: true,
        type: "String",
      },
    ];

    const headers = columns.map(column => {
      if (!column.shouldDisplay) {
        return null;
      }

      return intl.formatMessage({
        id: column.displayLabel,
        defaultMessage: column.displayLabel,
      });
    });

    const rows = employees.map(item => {
      return columns.map((column, i) => {
        const displayLabel = item[column.fieldId];
        const employeeName = decodeHtmlContent(item.employeeName);
        return (
          <Link
            key={i}
            to={`${RouteMap.AddDelegation}/${item.employeeKey}/${encodeURIComponent(employeeName)}`}
            onClick={() => onAddEmployee(item)}
          >
            {typeof displayLabel == "string" ? renderAsHTML("span", displayLabel) : displayLabel}
          </Link>
        );
      });
    });

    return (
      <div className="apl-scroll-table">
        <DataTable headers={headers} rows={rows} />
        {children}
      </div>
    );
  }
);

export default SearchEmployeeDelegationTable;



// WEBPACK FOOTER //
// ./components/employee/delegation/SearchEmployeeDelegationTable.js